import React from 'react';

// App-wide last-resort error boundary: a render crash used to unmount the whole
// tree and leave a white page — no message, no way out (worst inside the
// Messenger in-app browser, which has no reload affordance). System fonts +
// inline styles only: this must render even when the crash came from a theme
// or context provider.
export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    try { console.error('Render crash:', error, info?.componentStack); } catch { /* noop */ }
  }

  handleReload = () => {
    // Cache-busting reload (same trick as the boot splash): recovers devices
    // holding a poisoned cached index.html, not just transient crashes.
    try {
      const u = new URL(window.location.href);
      u.searchParams.set('bust', Date.now().toString(36));
      window.location.replace(u.toString());
    } catch { window.location.reload(); }
  };

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{
        position: 'fixed', inset: 0, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: 14, padding: 24,
        background: '#F5F5F0', color: '#475569', textAlign: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#1A1A1A' }}>Something went wrong</div>
        <div style={{ fontSize: 13, maxWidth: 340 }}>The page hit an unexpected error. Reloading usually fixes it.</div>
        <button onClick={this.handleReload} style={{
          padding: '10px 24px', borderRadius: 999, border: 0,
          background: '#1A4D2E', color: '#fff', fontSize: 14, fontWeight: 600, cursor: 'pointer',
        }}>Reload</button>
      </div>
    );
  }
}
